<template>
  <el-dialog title="Tips" :visible.sync="selfShow" width="600px">
    <el-form :model="model" label-width="200px">
      <el-form-item :label="$t('tariff_name')">
        <el-input v-model="model.tariff_name" required />
      </el-form-item>
      <br />
      <el-divider content-position="left"
        >{{ $t("tariff_cost") }}&nbsp;
        <el-button size="small" v-t="'add_new'" @click="dialogVisible = true" />
      </el-divider>
      <el-form-item
        v-for="v in Object.keys(model.tariff_cost || {})"
        :key="v"
        :label="v"
      >
        <div
          style="display: flex; justify-content: space-between; align-items: center"
        >
          <el-input
            :value="model.tariff_cost[v]"
            size="small"
            @input="
              t => {
                handleCostEdit(v, t);
              }
            "
          />
          <el-button
            size="small"
            icon="el-icon-delete"
            style="color:red"
            @click="handleRemoveCost(v)"
          />
        </div>
      </el-form-item>
      <br />
      <el-divider content-position="left">{{ $t("limits") }}</el-divider>
      <el-form-item v-for="v in limits_schema" :key="v" :label="v">
        <el-input size="small" v-model="model.limits[v]" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel" v-t="'actions.cancel'" />
      <el-button
        type="primary"
        @click="handleSave"
        :disabled="
          !model.tariff_name || nameExist(model.tariff_name, model.uuid)
        "
        v-t="'actions.add'"
      />
    </span>
    <add-new-tariff-cost
      v-if="dialogVisible"
      :visible.sync="dialogVisible"
      @add="handleAddCost"
    />
  </el-dialog>
</template>

<script>
import AddNewTariffCost from "./add_new_tariff_cost";
import SharedAmocrmLicensesCost from "../../../store/classes/SharedAmocrmLicensesCost";
import { mapGetters } from "vuex";

export default {
  name: "editAmoLicenses",
  components: { AddNewTariffCost },
  props: {
    value: {
      type: Object
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      model: Object.assign({}, JSON.parse(JSON.stringify(this.value))),
      dialogVisible: false,
      limits_schema: ["leads", "contacts", "cf"]
    };
  },
  methods: {
    handleAddCost(v) {
      if (!this.model.tariff_cost || Array.isArray(this.model.tariff_cost)) {
        this.$set(this.model, "tariff_cost", {});
      }
      if (!v.name || (this.model.tariff_cost[v.name] && !v.value)) {
        return;
      }
      this.$set(this.model.tariff_cost, v.name, v.value);
    },
    handleSave() {
      this.$emit("save", Object.assign({}, this.model));
      this.selfShow = false;
    },
    handleCancel() {
      this.$emit("cancel");
      this.selfShow = false;
    },
    handleRemoveCost(v) {
      this.$confirm(`Delete ${v}?`)
        .then(() => {
          delete this.model.tariff_cost[v];
          this.model.tariff_cost = Object.assign({}, this.model.tariff_cost);
        })
        .catch(() => {});
    },
    handleCostEdit(v, t) {
      this.model.tariff_cost[v] = t;
    }
  },
  computed: {
    ...mapGetters("shared_amocrm_licenses_cost_list", ["nameExist"]),
    selfShow: {
      get: function() {
        return this.visible;
      },
      set: function(v) {
        this.$emit("update:visible", v);
      }
    }
  }
};
</script>

<style scoped></style>
